import styled from 'styled-components';

export const tableBodyStyle = { fontSize: 14, padding: '15px 15px' };

export const TableWrapper = styled.div`
  overflow: auto;
`;

export const Wrapper = styled.div`
  padding: 45px 0 0;
  padding-bottom: 0px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 9px;
`;

export const Buttons = styled.div`
  display: flex;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 20px;
`;
